/** actions.js
 * vuex における action を定義する。
 * mutation は state を変更する唯一の操作で、同期処理のみ
 * を行うものであるのに対して、
 * action は非同期的な処理を行うことができる（ API のリクエストなど~
 */
import {
  RESERVATIONS_UPDATE,
  USERINFO_UPDATE,
  LECTURE_UPDATE,
  USER_LECTURES_FETCH,
  CLASSROOMS_FETCH,
  USER_LIST_UPDATE,
  LOGIN,
  LOGOUT,
  ATTENDANCE_UPDATE,
  SET_RESCHEDULING_INFO

} from './mutation_types'
import axios from 'axios'
import tokenApi from '@/api/token'
import reservationsApi from '@/api/reservations'
import lecturesApi from '@/api/lectures'
import userinfoApi from '@/api/user_information'
import recurrentApi from '@/api/recurrent_reservations'
import usersApi from '@/api/users'
import informationsApi from '@/api/informations'
import classroomsApi from '@/api/classrooms'
import attendanceApi from '@/api/attendance'
import temporalStudentsApi from '@/api/temporal_students'
import notTemporalStudentsApi from '@/api/not_temporal_students'
import reschedulingApi from '@/api/reschedulings'
import mailsApi from '@/api/mails'
import monthReport from '@/api/month_end_report'
import router from '@/router/index'
import State from './state'

function sendErrorSlack (text) {
  const BASE_URL = `https://hooks.slack.com/services/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`
  const user = State.userInfo.fullname
  var now = new Date()
  var year = now.getFullYear()
  var mon = now.getMonth() + 1
  var day = now.getDate()
  var hour = now.getHours()
  var min = now.getMinutes()
  var sec = now.getSeconds()
  // 出力用
  var date = year + '年' + mon + '月' + day + '日' + hour + '時' + min + '分' + sec + '秒'
  const sendMesseage = '発生日時:' + date + '\n報告者:' + user + '\n内容:' + text
  let options = {
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    data: `payload={
        "text": "` + sendMesseage + `",
    }`
  }
  axios.request(options)
}

function handleErrorGetReservations (error) {
  if (error.response) {
    let status = error.response.status
    let message = error.response.data.message
    sendErrorSlack(message)
    if (status === 401) {
      alert('セッションがタイムアウトしました　再度ログインして下さい')
      router.push('/login')
    } else {
      console.error(message)
      alert('予約情報取得に失敗しました：' + message)
    }
  } else {
    alert('Error:' + error.message)
  }
}

export default {
  /** getReservations : 予約のリストを取得する
   * @arg {Object} : \{commit\} - vuex組み込みのmutation呼び出し関数
   * @arg {Object} : query - クエリのオブジェクト
   * }
   */
  getReservations ({ commit }, query) {
    console.log(query)
    if (query.id !== undefined) {
      return reservationsApi.getById(query.id)
      .then((response) => {
        commit(RESERVATIONS_UPDATE, response.data.reservations)
        return response
      })
      .catch((err) => {
        handleErrorGetReservations(err)
      })
    } else if (query.date !== undefined) {
      if (query.all) {
        // allフラグが立っている（＝削除されたユーザの分の予約一覧も取得する）場合
        return reservationsApi.getAllByDate(query)
        .then((response) => {
          commit(RESERVATIONS_UPDATE, response.data.reservations)
        })
        .catch((err) => {
          handleErrorGetReservations(err)
        })
      } else {
        // allフラグが立っていない場合
        return reservationsApi.getByDate(query)
        .then((response) => {
          commit(RESERVATIONS_UPDATE, response.data.reservations)
        })
        .catch((err) => {
          handleErrorGetReservations(err)
        })
      }
    } else if (query.user_id !== undefined) {
      return reservationsApi.getByUserId(query.user_id)
      .then((response) => {
        commit(RESERVATIONS_UPDATE, response.data.reservations)
      })
      .catch((err) => {
        handleErrorGetReservations(err)
      })
    } else if (query.recurrence_id !== undefined) {
      return reservationsApi.getByRecurrenceId(query.recurrence_id)
      .then((response) => {
        commit(RESERVATIONS_UPDATE, response.data.reservations)
      })
      .catch((err) => {
        handleErrorGetReservations(err)
      })
    } else {
      return reservationsApi.get()
      .then((response) => {
        commit(RESERVATIONS_UPDATE, response.data.reservations)
      })
      .catch((err) => {
        handleErrorGetReservations(err)
      })
    }
  },
  /** postReservation : 予約を投稿する
   * @arg {Object} : \{commit\} - vuex組み込みのmutation呼び出し関数
   * @arg {Object} : reservation - 予約オブジェクト
  */
  postReservation ({ commit }, reservation) {
    return reservationsApi.post(reservation)
    .then((res) => {
      commit(RESERVATIONS_UPDATE)
      return res
    })
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        let errormessage = message + '\n[header]\n' + JSON.stringify(reservation)
        sendErrorSlack(errormessage)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else if (status === 400) {
          if (message === '日時と教室が既に登録されている予約と重複しています') {
            alert('既に登録されている予約と教室が重なっています')
          } else if (message === '日時と生徒または教師が既に登録されている予約と重複しています') {
            alert('既に登録されている予約と生徒または教師が重なっています')
          } else {
            console.error(message)
            alert('予約登録に失敗しました：' + message)
          }
        } else {
          console.error(message)
          alert('予約登録に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  editReservation ({ commit }, reservation) {
    return reservationsApi.put(reservation.id, reservation.reservation)
    .then((res) => {
      commit(RESERVATIONS_UPDATE)
    })
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        let errormessage = message + '\n[header]\n' + JSON.stringify(reservation)
        sendErrorSlack(errormessage)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else if (status === 400) {
          if (message === '日時と教室が既に登録されている予約と重複しています') {
            alert('既に登録されている予約と教室が重なっています')
          } else if (message === '日時と生徒または教師が既に登録されている予約と重複しています') {
            alert('既に登録されている予約と生徒または教師が重なっています')
          } else {
            console.error(message)
            alert('予約の変更に失敗しました：' + message)
          }
        } else {
          console.error(message)
          alert('予約の変更に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  deleteReservation ({ commit }, id) {
    return reservationsApi.delete(id)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        let errormessage = message + '\n[header]\n' + id
        sendErrorSlack(errormessage)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else if (status === 400) {
          alert('予約の削除に失敗しました：' + message)
        } else {
          console.error(message)
          alert('予約の削除に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  getUserInfo ({ commit }) {
    return userinfoApi.get()
    .then((res) => {
      commit(USERINFO_UPDATE, res.data)
    })
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          console.error(message)
          alert('ユーザ情報取得に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  getLectures ({ commit }, query) {
    if (query.hasOwnProperty('id')) {
      return lecturesApi.getById()
      .catch((err) => {
        if (err.response) {
          let status = err.response.status
          let message = err.response.data.message
          let errormessage = message + '\n[header]\n' + JSON.stringify(query)
          sendErrorSlack(errormessage)
          if (status === 401) {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          } else {
            console.error(message)
            alert('講義情報取得に失敗しました：' + message)
          }
        } else {
          alert('Error:' + err.message)
        }
      })
    } else {
      return lecturesApi.get()
      .then((res) => {
        commit(LECTURE_UPDATE, res.data.lectures)
      })
      .catch((err) => {
        if (err.response) {
          let status = err.response.status
          let message = err.response.data.message
          sendErrorSlack(message)
          if (status === 401) {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          } else {
            console.error(message)
            alert('講義情報取得に失敗しました：' + message)
          }
        } else {
          alert('Error:' + err.message)
        }
      })
    }
  },
  addLecture ({ commit }, lecture) {
    return lecturesApi.post(lecture)
      .catch((err) => {
        if (err.response) {
          let status = err.response.status
          let message = err.response.data.message
          sendErrorSlack(message)
          switch (status) {
            case 401:
              alert('セッションがタイムアウトしました　再度ログインして下さい')
              router.push('/login')
              break
            case 400:
              console.error(message)
              if (message.includes('パラメータが不正')) {
                alert('講義の登録に失敗しました． :' + message)
              } else {
                alert('講義の登録に失敗しました． :指定された教師または生徒が存在しません．')
              }
              break
            case 409:
              alert('すでに登録済みの講義です．')
              break
            default:
              alert('講義の登録に失敗しました． :' + message)
              break
          }
        } else {
          alert('Error :' + err.message)
        }
      })
  },
  deleteLecture ({ commit }, id) {
    return lecturesApi.delete(id).then((res) => {
    })
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          console.error(message)
          alert('講義の削除に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  getRecurrentReservations ({ commit }) {
    return recurrentApi.get().then((res) => {
    })
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          console.error(message)
          alert('繰り返し予約情報取得に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  postRecurrentReservations ({ commit }, reservation) {
    return recurrentApi.post(reservation)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        let errormessage = message + '\n[header]\n' + JSON.stringify(reservation)
        sendErrorSlack(errormessage)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          console.error(message)
          alert('繰り返し予約情報登録に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  editRecurrentReservations ({ commit }, reservation) {
    return recurrentApi.put(reservation.id, reservation.reservation)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        let errormessage = message + '\n[header]\n' + JSON.stringify(reservation)
        sendErrorSlack(errormessage)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          console.error(message)
          alert('繰り返し予約の変更に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  deleteRecurrentReservations ({ commit }, param) {
    return recurrentApi.delete(param.id, param.fromReservaitonId)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          console.error(message)
          alert('繰り返し予約の削除に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  addUser ({ commit }, user) {
    return usersApi.post(user)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        let errormessage = message + '\n[header]\n' + JSON.stringify(user)
        sendErrorSlack(errormessage)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else if (status === 409) {
          alert('ユーザーの登録に失敗しました．同じユーザー名がすでに登録されています')
          console.error(message)
        } else {
          alert('ユーザーの登録に失敗しました．:' + message)
        }
      } else {
        alert('Error: ' + err.message)
      }
    })
  },
  deleteUser ({ commit }, id) {
    return usersApi.delete(id)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          alert('ユーザーの削除に失敗しました. :' + message)
        }
      } else {
        alert('Error: ' + err.message)
      }
    })
  },
  getUserLectures ({ commit }, userId) {
    return lecturesApi.getByUserId(userId)
    .then((res) => {
      commit(USER_LECTURES_FETCH, res.data.lectures)
    })
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          console.error(message)
          alert('講義情報取得に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  getClassrooms ({ commit }, id) {
    return classroomsApi.get(id)
    .then((res) => {
      let classrooms = [...res.data.classrooms.slice(0, 2), ...res.data.classrooms.slice(2).sort((a, b) => (a.name.split('\n')[1] < b.name.split('\n')[1]) ? -1 : 1)]
      // commit(CLASSROOMS_FETCH, res.data.classrooms)
      commit(CLASSROOMS_FETCH, classrooms)
    })
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          console.error(message)
          alert('教室情報の取得に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  createClassroom ({ commit }, classroom) {
    return classroomsApi.post(classroom)
    .then((res) => {
      if (res.data.id) {
        alert('教室の登録に成功しました．')
      }
    })
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          console.error(message)
          alert('教室情報の登録に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  deleteClassroom ({ commit }, id) {
    return classroomsApi.delete(id)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          alert('教室の削除に失敗しました. :' + message)
        }
      } else {
        alert('Error: ' + err.message)
      }
    })
  },
  editClassroom ({ commit }, classroom) {
    return classroomsApi.put(classroom)
      .then((res) => {
        if (res.data.id) {
          alert('教室情報の変更に成功しました．')
        }
      })
      .catch((err) => {
        if (err.response) {
          let status = err.response.status
          let message = err.response.data.message
          sendErrorSlack(message)
          if (status === 401) {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          } else {
            console.error(message)
            alert('教室情報の変更に失敗しました：' + message)
          }
        } else {
          alert('Error:' + err.message)
        }
      })
  },
  updateUserList ({ commit }) {
    return usersApi.get()
    .then((res) => {
      commit(USER_LIST_UPDATE, res.data.users)
    })
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          console.error(message)
          alert('生徒一覧の取得に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  changeUserInfo ({ commit }, param) {
    return usersApi.put(param.id, param.user_info)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          } else if (message === '現在のパスワードが間違っています') {
            alert('現在のパスワードが間違っています．')
          } else {
            console.error(message)
            alert('ユーザ情報の変更に失敗しました ' + message)
          }
        } else if (status === 404) {
          alert('指定されたユーザが見つかりません')
        } else {
          console.error(message)
          alert('ユーザ情報の変更に失敗しました ' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
      return Promise.reject()
    })
  },
  changeUserPassword ({ commit }, creds) {
    return usersApi.putPassword(creds)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          } else if (message === '現在のパスワードが間違っています') {
            alert('現在のパスワードが間違っています．')
          } else {
            console.error(message)
            alert('パスワードの変更に失敗しました： ' + message)
          }
        } else if (status === 404) {
          alert('指定されたユーザが見つかりません')
        } else {
          console.error(message)
          alert('パスワードの変更に失敗しました： ' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  changeUserName ({ commit }, param) {
    return usersApi.putUserName(param)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          } else {
            console.error(message)
            alert('ユーザ名の変更に失敗しました： ' + message)
          }
        } else if (status === 404) {
          alert('指定されたユーザが見つかりません')
        } else {
          console.error(message)
          alert('ユーザ名の変更に失敗しました： ' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  changeFullname ({ commit }, param) {
    return usersApi.putFullname(param)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          } else {
            console.error(message)
            alert('氏名の変更に失敗しました： ' + message)
          }
        } else if (status === 404) {
          alert('指定されたユーザが見つかりません')
        } else {
          console.error(message)
          alert('氏名の変更に失敗しました： ' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  changeMailAddress ({ commit }, param) {
    return usersApi.putMailAddress(param)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          } else {
            console.error(message)
            alert('メールアドレスの変更に失敗しました： ' + message)
          }
        } else if (status === 404) {
          alert('指定されたユーザが見つかりません')
        } else {
          console.error(message)
          alert('メールアドレスの変更に失敗しました： ' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  changeStatus ({ commit }, param) {
    return usersApi.putStatus(param)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          } else {
            console.error(message)
            alert('ステータスの変更に失敗しました： ' + message)
          }
        } else if (status === 404) {
          alert('指定されたユーザが見つかりません')
        } else {
          console.error(message)
          alert('ステータスの変更に失敗しました： ' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  login ({ commit }, creds) {
    commit(LOGIN)
    let ret = {}
    return tokenApi.post(creds).then((res) => {
      ret = res.data.access_token
      localStorage.setItem('token', ret)
    })
    // ログイン後リダイレクトする処理の関係で，エラーハンドリングはLogin.vueで行う（少し気持ち悪いが）
  },
  logout ({ commit }) {
    localStorage.removeItem('token')
    commit(LOGOUT)
  },
  getAttendance ({ commit }) {
    return attendanceApi.get()
    .then((response) => {
      commit(ATTENDANCE_UPDATE, response.data.attendance)
    })
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          console.error(message)
          alert('来塾状況取得に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  toggleAttendance ({ commit }, userId) {
    return attendanceApi.post(userId)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          }
        } else {
          console.error(message)
          alert('来塾状況の変更に失敗しました： ' + message)
        }
      }
    })
  },
  getTemporalStudentByFullname ({ commit }, fullname) {
    return temporalStudentsApi.getByFullname(fullname)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        let errormessage = message + '\n' + fullname
        sendErrorSlack(errormessage)
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          }
        } else if (status === 404) {
          throw err
        } else {
          console.error(message)
          alert('一時的な生徒の取得に失敗しました' + message)
        }
      }
    })
  },
  setReschedulingInfo ({ commit }, reschedulingInfo) {
    commit(SET_RESCHEDULING_INFO, reschedulingInfo)
  },
  postReschedulings ({ commit }, params) {
    return reschedulingApi.post(params)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        let errormessage = message + '\n[header]\n' + JSON.stringify(params)
        sendErrorSlack(errormessage)
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          }
        } else {
          console.error(message)
          alert('授業振替情報の登録に失敗しました ' + message)
        }
      }
    })
  },
  getAllReschedulings ({ commit }) {
    return reschedulingApi.get()
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          }
        } else if (status === 404) {
          console.error(message)
        } else {
          console.error(message)
          alert('授業振替情報の取得に失敗しました　' + message)
        }
      }
    })
  },
  getReschedulingByHash ({ commit }, hash) {
    return reschedulingApi.getByHash(hash)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          }
        } else if (status === 404) {
          console.error(message)
        } else {
          console.error(message)
          alert('授業振替情報の取得に失敗しました　' + message)
        }
      }
    })
  },
  getReschedulingetList ({ commit }, id) {
    return reschedulingApi.getList(id)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          }
        } else if (status === 404) {
          console.error(message)
        } else {
          console.error(message)
          alert('授業振替情報の取得に失敗しました　' + message)
        }
      }
    })
  },
  sendUserInfoMail ({ commit }, data) {
    return mailsApi.postUserInfoChange(data)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          }
        } else {
          console.error(message)
          alert('変更通知メールの送信に失敗しました(' + message + ')')
        }
      }
      throw err
    })
  },
  sendMailReschedulingRequest ({ commit }, hash) {
    return mailsApi.postReschedulingRequest(hash)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          }
        } else {
          console.error(message)
          alert('授業振替依頼メールの送信に失敗しました(' + message + ')')
        }
      }
      throw err
    })
  },
  updateReschedulingInfo ({ commit }, reservation) {
    return reschedulingApi.put(reservation.hash, reservation.reservation)
    .then((res) => {
      commit(RESERVATIONS_UPDATE)
    })
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else if (status === 400) {
          if (message === '日時と教室が既に登録されている予約と重複しています') {
            alert('既に登録されている予約と教室が重なっています')
          } else if (message === '日時と生徒または教師が既に登録されている予約と重複しています') {
            alert('既に登録されている予約と生徒または教師が重なっています')
          } else {
            console.error(message)
            alert('予約登録に失敗しました：' + message)
          }
        } else {
          console.error(message)
          alert('予約登録に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  sendMailReschedulingResult ({ commit }, hashs) {
    return mailsApi.postReschedulingResult(hashs)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          }
        } else {
          console.error(message)
          alert('授業振替依頼メールの送信に失敗しました( ' + message + ')')
        }
      }
    })
  },
  sendMailReschedulingError ({ commit }, hashs) {
    return mailsApi.postReschedulingError(hashs)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          if (message === 'トークンが無効です') {
            alert('セッションがタイムアウトしました　再度ログインして下さい')
            router.push('/login')
          }
        } else {
          console.error(message)
          alert('事務局へのエラー報告に失敗しました(' + message + ')')
        }
      }
    })
  },
  getNotTemporalStudentByFullname ({ commit }, fullname) {
    return notTemporalStudentsApi.getByFullname(fullname)
  },
  getInformation ({ commit }) {
    return informationsApi.get()
    .then((res) => {
      return res.data.informations
    })
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          alert('ユーザ情報取得に失敗しました：' + message)
        }
      } else {
        alert('Error:' + err.message)
      }
    })
  },
  addinformation ({ commit }, information) {
    return informationsApi.post(information)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          alert('お知らせの登録に失敗しました．:' + message)
          return 1
        }
      } else {
        alert('Error: ' + err.message)
        return 1
      }
    })
  },
  editinformation ({commit}, data) {
    return informationsApi.put(data)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          alert('お知らせの編集に失敗しました. :' + message)
          return 1
        }
      } else {
        alert('Error: ' + err.message)
        return 1
      }
    })
  },
  deleteinformation ({ commit }, id) {
    return informationsApi.delete(id)
    .catch((err) => {
      if (err.response) {
        let status = err.response.status
        let message = err.response.data.message
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          alert('お知らせの削除に失敗しました. :' + message)
          return 1
        }
      } else {
        alert('Error: ' + err.message)
        return 1
      }
    })
  },
  exportRport ({ commit }, data) {
    return monthReport.post(data)
    .catch((err) => {
      if (err.response) {
        console.log(err.response)
        let status = err.response.status
        let message = err.response.data
        sendErrorSlack(message)
        if (status === 401) {
          alert('セッションがタイムアウトしました　再度ログインして下さい')
          router.push('/login')
        } else {
          alert('月末報告書の発行に失敗しました. :' + message)
          return 1
        }
      } else {
        alert('Error: ' + err.message)
        return 1
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js